import { z } from "zod";
import { paginationSchema } from "./common.js";

export const exportKindSchema = z.enum([
  "payroll-summary",
  "site-cost",
  "equipment-usage",
  "exceptions",
  "audit",
  "pay-period-csv",
  "pay-period-pdf",
  "pay-period-payroll",
  "pay-period-summary-pdf",
  "site-cost-pdf",
  "worker-detail-pdf",
  "equipment-usage-pdf",
]);

export const exportBatchStatusSchema = z.enum(["PENDING", "PROCESSING", "COMPLETED", "FAILED"]);

export const exportFiltersSchema = z.object({
  payPeriodId: z.string().uuid().optional(),
  siteId: z.string().uuid().optional(),
  workerId: z.string().uuid().optional(),
  crew: z.string().optional(),
  equipmentId: z.string().uuid().optional(),
  jobCode: z.string().optional(),
  costCode: z.string().optional(),
  dateFrom: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  dateTo: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
});

export const exportBatchIdParamSchema = z.object({
  exportBatchId: z.string().uuid(),
});

export const createExportResponseSchema = z.object({
  exportBatchId: z.string().uuid(),
  status: exportBatchStatusSchema,
  queued: z.boolean(),
});

export const exportBatchSummarySchema = z.object({
  id: z.string().uuid(),
  exportKind: exportKindSchema.nullable(),
  type: z.enum(["CSV", "PDF", "PAYROLL"]),
  status: exportBatchStatusSchema,
  fileName: z.string().nullable(),
  rowCount: z.number().int().nullable(),
  payPeriodId: z.string().uuid().nullable(),
  generatedBy: z.string().uuid(),
  generatedByName: z.string().nullable(),
  generatedAt: z.string().nullable(),
  createdAt: z.string(),
  errorMessage: z.string().nullable(),
  downloadPath: z.string().nullable(),
});

export const exportListQuerySchema = paginationSchema.extend({
  status: exportBatchStatusSchema.optional(),
  exportKind: exportKindSchema.optional(),
});

export type ExportKind = z.infer<typeof exportKindSchema>;
export type ExportBatchStatus = z.infer<typeof exportBatchStatusSchema>;
export type ExportFilters = z.infer<typeof exportFiltersSchema>;
export type CreateExportResponse = z.infer<typeof createExportResponseSchema>;
export type ExportBatchSummary = z.infer<typeof exportBatchSummarySchema>;
